import { useBlockProps } from '@wordpress/block-editor';

export default function save( { attributes } ) {
	const { title, image_id, image, link } = attributes;

	return (		
		<div { ...useBlockProps.save() }>
			<div>{title}</div>
			<div>{image_id}</div>
			<div>{image}</div>
			<div>{link}</div>
		</div>
	);
}